import ChannelEncoder from './ChannelEncoder';
import { CompleteAxisConfig } from '../fillers/completeAxisConfig';
import { ChannelInput, StringLike, AnyChannelDef } from '../types';
import parseDateTime from '../parsers/parseDateTime';
import inferElementTypeFromUnionOfArrayTypes from '../utils/inferElementTypeFromUnionOfArrayTypes';
import { isDateTime } from '../typeGuards/DateTime';
import createFormatter from '../parsers/format/createFormatter';

export default class ChannelEncoderAxis<Def extends AnyChannelDef> {
  readonly channelEncoder: ChannelEncoder<Def>;

  readonly config: Exclude<CompleteAxisConfig, false>;

  readonly formatValue: (value: ChannelInput | StringLike) => string;

  constructor(channelEncoder: ChannelEncoder<Def>) {
    this.channelEncoder = channelEncoder;
    this.config = channelEncoder.definition.axis as Exclude<CompleteAxisConfig, false>;
    this.formatValue = createFormatter(this.config);
  }

  getTitle() {
    return this.config.title;
  }

  hasTitle() {
    const { title } = this.config;

    return title !== null && typeof title !== 'undefined' && title !== '';
  }

  getTickLabels() {
    const { tickCount, values } = this.config;

    if (typeof values !== 'undefined') {
      return inferElementTypeFromUnionOfArrayTypes(values).map(v =>
        this.formatValue(isDateTime(v) ? parseDateTime(v) : v),
      );
    }

    const { scale } = this.channelEncoder;
    if (scale && 'domain' in scale) {
      const ticks: (string | number | Date | StringLike)[] =
        'ticks' in scale ? scale.ticks(tickCount) : scale.domain();
      return ticks.map(this.formatValue);
    }

    return [];
  }
}
